import { registerPlugin } from '@capacitor/core';
import type { SaveToGalleryPlugin } from './SaveToGalleryDefinitions';

const SaveToGallery = registerPlugin<SaveToGalleryPlugin>('SaveToGalleryPlugin', {
  web: () => import('./SaveToGalleryWeb').then(m => new m.SaveToGalleryPluginWeb()),
});

export * from './SaveToGalleryDefinitions';
export default SaveToGallery;
